<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useUiStore } from './stores/ui.ts';

const uiStore = useUiStore();

onMounted(() => {
  uiStore.initThemes();
});
</script>

<template>
  <div class="min-h-screen flex flex-col flex-1 font-sans antialiased selection:bg-orange-600/30 selection:text-orange-200 p-0 m-0 w-full">
    <RouterView />
  </div>
</template>
